import React, { useState } from 'react'
import Image from 'next/image'
import styles from './Contact.module.scss'
import Cookies from 'js-cookie'
import Select, { Options, SingleValue } from 'react-select'
import CustomSelect, { Value } from '../../components/customSelect/CustomSelect'
import { widont } from '../../utils/typography'
import { useGlobalContentContext } from '../../context/GlobalContentContext'

type ContactProps = {
  title?: string
  hideTitle?: boolean
}

const Contact = (props: ContactProps) => {
  const { data } = useGlobalContentContext()

  const hutk = Cookies.get('hubspotutk')

  const [formSubmitted, setFormSubmitted] = useState<boolean>(false)
  const [messageRows, setMessageRows] = useState<number>(2)

  const handleSubmit = async (event: React.SyntheticEvent) => {
    // Stop the form from submitting and refreshing the page.
    event.preventDefault()

    setFormSubmitted(true)

    const target = event.target as typeof event.target & {
      firstname: { value: string }
      lastname: { value: string }
      email: { value: string }
      subject: { value: string }
      message: { value: string }
    }
    // Get data from the form.
    const data = {
      firstname: target.firstname.value,
      lastname: target.lastname.value,
      email: target.email.value,
      subject: subjectValue,
      message: target.message.value,
      hutk: hutk ? hutk : '',
    }

    // Send the data to the server in JSON format.
    const JSONdata = JSON.stringify(data)
    // API endpoint where we send form data.
    const endpoint = '/api/contact'

    // Form the request for sending data to the server.
    const options = {
      // The method is POST because we are sending data.
      method: 'POST',
      // Tell the server we're sending JSON.
      headers: {
        'Content-Type': 'application/json',
      },
      // Body of the request is the JSON data we created above.
      body: JSONdata,
    }

    // Send the form data to our forms API on Vercel and get a response.
    const response = await fetch(endpoint, options)

    // Get the response data from server as JSON.
    // If server returns the name submitted, that means the form works.
    const result = await response.json()
  }

  const inquiryOptions = [
    // { value: '', label: 'Please Select' },
    { value: 'General Inquiry', label: 'General Inquiry' },
    { value: 'Product', label: 'Product' },
    { value: 'Manufacturing', label: 'Manufacturing' },
    { value: 'Media', label: 'Media' },
    { value: 'Careers', label: 'Careers' },
  ]
  const [subjectValue, setSubjectValue] = useState<string>(
    inquiryOptions[0].value
  )

  const handleSubjectChange = (value: Value) => {
    setSubjectValue(value.value)
  }
  return (
    <section className={styles.section}>
      <div
        className={`${
          props.hideTitle ? styles.containerNoPadding : styles.container
        }`}
      >
        {!props.hideTitle && (
          <h2 className={styles.title}>
            {props.title ? props.title : data.contact ? data.contact.title : ''}
          </h2>
        )}
        {data.contact && (
          <div
            className={styles.detail}
            dangerouslySetInnerHTML={{
              __html: widont(data.contact?.detail),
            }}
          ></div>
        )}
        <div id="my-hubspot-form" />
        <div className={styles.form}>
          {!formSubmitted ? (
            <form onSubmit={handleSubmit}>
              <div className={styles.formGroupContainer}>
                <div className={styles.formGroup}>
                  <input
                    type="text"
                    name="firstname"
                    placeholder="First Name"
                    required
                  />
                </div>
                <div className={styles.formGroup}>
                  <input
                    type="text"
                    name="lastname"
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <input type="email" name="email" placeholder="Email" required />
              </div>

              <div className={styles.formGroup}>
                <div className={styles.select}>
                  <CustomSelect
                    id="subject"
                    name="subject"
                    onChange={handleSubjectChange}
                    options={inquiryOptions}
                    placeholder="Please Select Subject"
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <textarea
                  name="message"
                  placeholder="Message"
                  rows={messageRows}
                  onClick={() => setMessageRows(6)}
                />
              </div>

              <button type="submit">
                <span className={styles.linkArrow}>
                  <Image src="/arrow-black.svg" layout="fill" alt="" />
                </span>{' '}
                Submit
              </button>
            </form>
          ) : (
            <div className={styles.formSubmitted}>
              Thanks for your interest in Sakuu. We will get back to you
              shortly.
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Contact
